export const checkIfNumber = (value: string): boolean => {
  const reg = new RegExp('^[0-9]+$');
  return reg.test(value);
};
